import { z } from 'zod'

export const validationSchema = z
  .object({
    password: z
      .string({ required_error: 'Senha é obrigatória' })
      .min(8, 'Digite no mínimo 8 caracteres')
      .max(128, 'Digite no máximo 128 caracteres')
      .regex(/^\S*$/, 'Senha não pode conter espaços'),
    passwordConfirmation: z
      .string({ required_error: 'Confirmação de senha é obrigatória' })
      .min(1, 'Confirmação de senha é obrigatória')
  })
  .refine(data => data.password === data.passwordConfirmation, {
    message: 'As senhas não são iguais',
    path: ['passwordConfirmation']
  })

export type ResetPasswordSchema = z.infer<typeof validationSchema>
